import { Ticket, TicketTypeBundle, TicketTypeGroup } from 'types/TicketsState';

export type ItemTree = TicketTypeGroup | Ticket | TicketTypeBundle;
export type GroupItemTree = Ticket | TicketTypeBundle;

export const getItemsTree = (
  ticketTypes: Ticket[],
  ticketTypeBundles: TicketTypeBundle[],
  groups: TicketTypeGroup[],
): ItemTree[] =>
  [
    ...ticketTypes.filter(({ idGroup }) => idGroup === null),
    ...ticketTypeBundles.filter(({ idGroup }) => idGroup === null),
    ...groups,
  ].sort((a, b) => a.order - b.order);

export const getGroupItemsTree = (
  id: number,
  ticketTypes: Ticket[],
  ticketTypeBundles: TicketTypeBundle[],
): GroupItemTree[] =>
  [
    ...ticketTypes.filter(({ idGroup }) => idGroup === id),
    ...ticketTypeBundles.filter(({ idGroup }) => idGroup === id),
  ].sort((a, b) => a.order - b.order);

export const isTicketType = (item: ItemTree): item is Ticket => 'limit' in item;

export const isTicketTypeBundle = (item: ItemTree): item is TicketTypeBundle =>
  'items' in item;
